import React from 'react'
import { useSelector } from 'hook'
import {
  GridList,
  GridListTile,
  GridListTileBar,
  Paper,
  Box,
} from '@material-ui/core'
import { LANGUAGE } from 'constants/language'
import SCROLL from 'constants/scrolls'
import useStyles from './style'
import { PhotoArticle } from 'text/article'
import { ContentTitle } from 'components/Parts'

const PhotoContent = () => {
  const classes = useStyles()
  const languageManager = useSelector((state) => state.languageManager)
  const isJP = languageManager === LANGUAGE.JP

  return (
    <Box className={classes.root}>
      <ContentTitle to={SCROLL.PHOTO}>
        {isJP ? PhotoArticle.title.jp : PhotoArticle.title.en}
      </ContentTitle>
      <Paper className={classes.grid} elevation={6}>
        <GridList cols={4.5} className={classes.grid_list}>
          {PhotoArticle.tiles.map((tile) => (
            <GridListTile key={tile.img}>
              <img src={tile.img} alt={tile.title.en} />
              <GridListTileBar
                title={isJP ? tile.title.jp : tile.title.en}
                className={classes.tile_bar}
              />
            </GridListTile>
          ))}
        </GridList>
      </Paper>
    </Box>
  )
}

export default PhotoContent
